import { render, staticRenderFns } from "./AxleLoadProgram.vue?vue&type=template&id=fc02c4c2&scoped=true&"
import script from "./AxleLoadProgram.vue?vue&type=script&lang=ts&"
export * from "./AxleLoadProgram.vue?vue&type=script&lang=ts&"
import style0 from "./AxleLoadProgram.vue?vue&type=style&index=0&id=fc02c4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc02c4c2",
  null
  
)

export default component.exports